/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from '../../Constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  register: (data) => {
    //console.log("data-->",data);
    return axios.post(API_ENDPOINTS.REGISTER, data, {
      headers: {
        "Content-Type": "application/json",
        "x-tenant-slug": "default"
       },
    })
  },
  registerV2: (formData) => {
    // Content-Type volontairement omis : le navigateur doit poser lui-même
    // le boundary multipart pour un FormData contenant des fichiers.
    return axios.post(API_ENDPOINTS.REGISTER_V2, formData, {
      headers: {
        "x-tenant-slug": "default",
      },
    })
  },
  registerEnterprise: (formData) => {
    // Content-Type volontairement omis : le navigateur doit poser lui-même
    // le boundary multipart pour un FormData contenant des fichiers.
    return axios.post(API_ENDPOINTS.REGISTER_ENTERPRISE, formData, {
      headers: {
        "x-tenant-slug": "default",
      },
    })
  },
  getUserInfoByCode: (code) => {
    return axios.get(API_ENDPOINTS.USER_INFO_BY_CODE, {
      params: { code },
      headers: {
        "x-tenant-slug": "default",
      },
    })
  },
}
